module.exports = __webpack_public_path__ + "media/honey-icons/icon-text-size-bcf788ce.svg";